import React from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { Message } from "lib/components/index"

import { MainView } from "lib/components/index"
import { fetchCurrentUser, fetchProducts, changeCurrentCompany, logout } from "modules/auth"
import { createAlert, pushRoute } from "modules/app/actions"

@connect(
  state => ({
    currentUser: state.auth.user,
    currentCompanyId: state.auth.companyId,
    fetchCurrentUserLoading: state.auth.fetchLoading,
    fetchCurrentUserFailed: state.auth.fetchFailed,
    fetchProductsFailed: state.auth.products.fetchFailed,
  }),
  dispatch => bindActionCreators({
    fetchCurrentUser,
    fetchProducts,
    changeCurrentCompany,
    pushRoute,
    createAlert,
    logout,
  }, dispatch)
)
export default function requireAuth(Component) {
  class AuthenticatedComponent extends React.PureComponent {
    componentDidMount() {
      this._checkAuth()
      this._respondToProps()
    }

    componentWillReceiveProps(nextProps) {
      this._checkAuth(nextProps)
    }

    componentDidUpdate(prevProps) {
      this._respondToProps(prevProps)
    }

    _checkAuth(props = this.props) {
      const { currentUser, pushRoute } = props
      if (!currentUser) {
        const redirectAfterLogin = props.location.pathname
        pushRoute(`/login?next=${encodeURIComponent(redirectAfterLogin)}`)
      }
    }

    _respondToProps(prevProps) {
      const { currentUser, currentCompanyId, pushRoute, changeCurrentCompany, createAlert } = this.props
      if (currentUser && currentUser.companies && (!prevProps || this.props.params.companyId !== prevProps.params.companyId || currentUser !== prevProps.currentUser)) {
        const nextCompanyId = this.props.params.companyId ? +this.props.params.companyId : null
        const nextCompanySaasSubdomain = this.props.location.query && this.props.location.query.c_by_saas_subdomain
        const nextCompany = nextCompanyId
          ? currentUser.companies && currentUser.companies.find(c => c.id === nextCompanyId)
          : nextCompanySaasSubdomain
            ? currentUser.companies && currentUser.companies.find(c => c.saas_subdomain === nextCompanySaasSubdomain)
            : null
        if (!nextCompany) {
          if (nextCompanyId) {
            createAlert({
              type: "error",
              content: I18n.t("papp.app.requireAuth.company_forbidden", { company_id: nextCompanyId })
            })
            pushRoute(`/c/${nextCompanyId}/404`)
          } else if (currentCompanyId) {
            pushRoute(`/c/${currentCompanyId}`)
          }
        } else if (nextCompany.id !== currentCompanyId) {
          changeCurrentCompany(nextCompany.id)
          if (nextCompany.id !== +this.props.params.companyId) {
            pushRoute(`/c/${nextCompany.id}`)
          }
        }
      }
    }

    render() {
      const {
        currentUser, currentCompanyId,
        fetchProductsFailed, fetchProducts,
        fetchCurrentUserLoading, fetchCurrentUserFailed, fetchCurrentUser,
        logout,
      } = this.props
      if (!currentUser) {
        return null
      } else if (!currentUser.id) {
        if (fetchCurrentUserLoading) {
          return <MainView.Dimmer loading />
        } else if (fetchCurrentUserFailed) {
          return (
            <MainView.Dimmer failed retry={fetchCurrentUser} />
          )
        } else {
          return null
        }
      } else if (!currentCompanyId) {
        if (currentUser.companies.length === 0) {
          return <MainView.Dimmer failed errorTitle={I18n.t("papp.app.requireAuth.no_companies_error_title")} retry={() => logout({ revokeToken: true })} />
        } else {
          return <MainView.Dimmer loading />
        }
      } else {
        if (fetchProductsFailed) {
          <MainView.Dimmer failed retry={fetchProducts} />
        } else {
          return <Component {...this.props} />
        }
      }
    }
  }

  return AuthenticatedComponent
}



// WEBPACK FOOTER //
// ./src/modules/app/requireAuth.jsx